import Settings from '../../utils/Settings';

class RnrSettings extends Settings {
  constructor() {
    super();
    this.endpoint = {
      'post-review': null,
      'get-review': null,
      'put-review': null,
      'delete-review': null,
      'get-user-review': null,
      'post-reply': null,
      'put-reply': null,
      'delete-reply': null,
      'get-reply': null,
      'get-replies-auth': null,
      'get-reviews-auth': null,
    };
  }
}

export const settings = new Settings();
export const reviewSettings = new RnrSettings();
export const arsEndpointSettings = new Settings();
export const rnrHeadEndpointSettings = new Settings();
